import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Cotizacion } from '../../../interface/Cotizacion';
import { PraxisService } from '../../../service/praxis.service';
//import {  } from "../../../interface/Cotizacion";

@Component({
    selector: 'app-solicitar-page',
    templateUrl: './solicitar-page.component.html',
    styleUrl: './solicitar-page.component.css',
    standalone: false
})
export class SolicitarPageComponent implements OnInit {

  cotizacion: Cotizacion | undefined = undefined;
  archivo: string = '';
  nombre: string | null = '';
  mensajes: string[] | undefined;
  constructor(
    private praxisService: PraxisService
  ){

  }


 ngOnInit(): void {

    this.nombre = localStorage.getItem('nombre');
    this.praxisService.getCotizarSolicitar(
                                          localStorage.getItem('token'),
                                          localStorage.getItem('uuid'),
                                          localStorage.getItem('ramo'),
                                          localStorage.getItem('solicitar'),
                                          localStorage.getItem('conducto_pago'),
                                          localStorage.getItem('iibb'),
                                          localStorage.getItem('iva'),
                                          localStorage.getItem('tipo_persona'),
                                          localStorage.getItem('tipo_matricula'),
                                          localStorage.getItem('matricula'),
                                          localStorage.getItem('codigo_especialidad'),
                                          localStorage.getItem('titulo'),
                                          localStorage.getItem('suma_asegurada'),
                                          localStorage.getItem('apellido'),
                                          localStorage.getItem('nombre'),
                                          localStorage.getItem('cp'),
                                          localStorage.getItem('calle'),
                                          localStorage.getItem('altura'),
                                          localStorage.getItem('tipo_documento'),
                                          localStorage.getItem('nrodoc'),
                                          localStorage.getItem('celular'),
                                          localStorage.getItem('email'),
                                          localStorage.getItem('numero_tarjeta'),
                                          localStorage.getItem('sexo'),
                                          this.obtenerFechaActual(),
                                          localStorage.getItem('jefe'),
                                          localStorage.getItem('director'),
                                          )
                      .subscribe(
                        (datos) => {
                          this.cotizacion = datos;
                          this.archivo = datos.reporte;
                          if(this.cotizacion.resultado=='Error'){
                            alert(this.cotizacion.mensajes);
                          }else{
                            localStorage.clear();
                          }
                        }
                      )
  }

  obtenerFechaActual() {
    let fecha = new Date();
    let year = fecha.getFullYear();
    let month = (fecha.getMonth() + 1).toString().padStart(2, '0'); // Agrega un cero al principio si el mes es menor a 10
    let day = fecha.getDate().toString().padStart(2, '0'); // Agrega un cero al principio si el día es menor a 10

    return `${year}${month}${day}`;
    //return this.fechaActual;
    //console.log(this.fechaActual); // Resultado: Por ejemplo, '20220513' para el 13 de mayo de 2022
  }

  downloadPdf(): void {
    // Decodifica la cadena Base64
    //console.log(this.archivo)
    const binaryString = atob(this.archivo);

    // Crea un array de bytes a partir de la cadena binaria
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    // Crea un objeto Blob a partir de los bytes
    const blob = new Blob([bytes], { type: 'application/pdf' });

    // Crea una URL basada en el objeto Blob
    const url = URL.createObjectURL(blob);
    // Abre la URL en una nueva pestaña y enfoca esa pestaña
    const newTab = window.open(url, '_blank');
    if (newTab) {
      newTab.focus();
    } else {
      alert('Permite las ventanas emergentes para ver el PDF.');
    }
  }


}
